import React, { useMemo } from "react";
import { connect } from "react-redux";

import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessages, useIntl } from "react-intl";

import { Divider } from "@mapmycustomers/ui";

import { getOrganizationEmailBoilerplateText } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import sanitizeEmailHtml from "@app/util/email/sanitizeEmailHtml";

import styles from "./EmailBoilerplate.module.scss";

const messages = defineMessages({
  subtitle: {
    id: "email.boilerplate.subtitle",
    defaultMessage: "Managed by your org",
    description: "Email boilerplate title",
  },
  title: {
    id: "email.boilerplate.title",
    defaultMessage: "Boilerplate",
    description: "Email boilerplate title",
  },
});

interface EmailBoilerplateProps {
  className?: string;
}

const EmailBoilerplate = ({
  boilerplateText,
  className,
}: EmailBoilerplateProps & ReturnType<typeof mapStateToProps>) => {
  const intl = useIntl();

  const sanitizedBoilerplate = useMemo(() => sanitizeEmailHtml(boilerplateText), [boilerplateText]);

  if (!boilerplateText) {
    return null;
  }

  return (
    <div className={className}>
      <div className={styles.header}>
        <FontAwesomeIcon icon={faLock} />
        <span className={styles.headerTitle}>{intl.formatMessage(messages.title)}</span>
        <span className={styles.headerSubtitle}>· {intl.formatMessage(messages.subtitle)}</span>
      </div>
      <Divider className={styles.divider} />
      {/* Org-admin-editable boilerplate — sanitize before render. */}
      <div dangerouslySetInnerHTML={{ __html: sanitizedBoilerplate }} />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  boilerplateText: getOrganizationEmailBoilerplateText(state),
});

export default connect(mapStateToProps)(EmailBoilerplate);
